import { useCallback, useEffect, useState } from "react";

/* Sync a Mist-studio sub-view to the browser URL query string so a mobile
   pull-to-refresh re-hydrates the exact tool instead of bouncing to the hub.
   Uses replaceState (view swaps don't add history entries); studio open/close
   pushState is handled by MistSuite. */
export function useStudioParam(key, def) {
  const read = () => new URLSearchParams(window.location.search).get(key) || def;
  const [val, setVal] = useState(read);

  const set = useCallback((v) => {
    setVal(v);
    const p = new URLSearchParams(window.location.search);
    if (v && v !== def) p.set(key, v);
    else p.delete(key);
    const qs = p.toString();
    window.history.replaceState(window.history.state, "", `${window.location.pathname}${qs ? `?${qs}` : ""}`);
  }, [key, def]);

  useEffect(() => {
    const onPop = () => setVal(read());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [val, set];
}
